// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".category-products .cart-button {\n  text-transform: initial;\n}\n.category-products .cursor-pointer {\n  cursor: pointer;\n}\n.category-products .cart-image {\n  vertical-align: middle;\n}\n.category-products .price strong {\n  display: inline-flex;\n  margin-top: 5px;\n  font-size: 13px;\n}\n.category-products .product-title {\n  text-transform: uppercase;\n}\n.category-products .description p {\n  margin-bottom: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
